export default __webpack_public_path__ + "static/media/6.212a691d.jpg";